var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondsChest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 368 333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffd100;\n      }\n\n      .cls-2 {\n        fill: #db8601;\n      }\n\n      .cls-3 {\n        fill: #20b0f6;\n      }\n\n      .cls-4 {\n        fill: #ab582c;\n      }\n\n      .cls-5 {\n        fill: #fbb802;\n      }\n\n      .cls-6 {\n        fill: #854623;\n      }\n\n      .cls-7 {\n        fill: #9ce1fa;\n      }\n\n      .cls-8 {\n        fill: #ffbc00;\n      }\n\n      .cls-9 {\n        fill: #fdbc03;\n      }\n\n      .cls-10 {\n        fill: #f5a301;\n      }\n\n      .cls-11 {\n        fill: #019fec;\n      }\n\n      .cls-12 {\n        fill: #83defc;\n      }\n\n      .cls-13 {\n        fill: #52d0ff;\n      }\n\n      .cls-14 {\n        fill: #8d4721;\n      }\n\n      .cls-15 {\n        fill: #24bafe;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 159,
    y: 44,
    width: 67,
    height: 27,
    rx: 5.87,
    ry: 5.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 84,
    y: 58,
    width: 217,
    height: 9,
    rx: 4.5,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 69,
    y: 64,
    width: 247,
    height: 158,
    rx: 22.32,
    ry: 22.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 85.5,
    y: 81.5,
    width: 214,
    height: 111
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.12,129.4l-5.95-17.2c-1.61-4.66-.28-9.84,3.4-13.13l27.52-24.69c3.34-3,8.06-3.93,12.29-2.43l31.94,11.36c3.87,1.38,6.79,4.59,7.78,8.58l10.94,43.76c1.82,7.29-3.28,14.49-10.77,15.18l-53.95,4.97c-4.77.44-9.35-1.94-11.74-6.08l-10.49-18.19c-.39-.67-.71-1.38-.97-2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M160.48,159.95l-.69-18.64c-.16-4.3,3.22-7.9,7.52-8.02l54.04-1.44c5.9-.16,9.79,6.08,7.06,11.31l-15.43,29.58c-1.49,2.86-4.61,4.5-7.82,4.1l-37.04-4.63c-3.35-.42-6.04-2.97-6.65-6.29l-.89-4.87c-.07-.36-.11-.73-.12-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M82.4,163.43l15.43-29.39c1.96-3.74,5.77-6.15,9.99-6.32l36.72-1.47c4.03-.16,7.86,1.74,10.16,5.04l26.72,38.25c5.59,8-.37,18.94-10.12,18.58l-77.26-2.84c-4.85-.18-9.1-3.3-10.71-7.88l-1.61-4.56c-1.09-3.1-.85-6.52.68-9.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M110.46,141.6l16.04,28.48c2.53,3.9,8.6,1.77,8.13-2.86l-7.67-29.32c-.25-2.43-2.42-4.2-4.85-3.96l-8.37.84c-3.3.33-5.08,4.04-3.28,6.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M200.99,125.11h0c.3-5.17,3.81-9.61,8.77-11.09l34.41-10.32c4.49-1.35,9.35-.04,12.55,3.38l19.53,20.83c3.21,3.43,4.2,8.38,2.55,12.77l-4.64,12.36c-2.52,6.72-10.23,9.88-16.75,6.86l-49.31-22.87c-4.6-2.13-7.42-6.86-7.13-11.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.03,164.44l25.9-37.74c2.21-3.22,5.95-5.05,9.86-4.83l38.03,2.24c4.11.24,7.76,2.73,9.48,6.47l19.16,41.63c3.34,7.25-1.8,15.57-9.78,15.82l-73.7,2.33c-2.88.09-5.68-.93-7.82-2.86l-9.4-8.46c-4.16-3.74-4.9-9.99-1.74-14.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M153.86,83.96l5.42,25.73c.56,2.66,3.73,3.8,5.86,2.1l20.31-16.25c2.22-1.78,1.65-5.3-1.02-6.28l-25.73-9.48c-2.7-.99-5.43,1.37-4.84,4.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M237.39,137.26l11.87,20.61c1.51,2.62,5.23,2.78,6.96.31l13.12-18.74c1.84-2.62.12-6.25-3.07-6.49l-24.98-1.87c-3.31-.25-5.54,3.31-3.89,6.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 113,
    y: 176,
    width: 160,
    height: 120
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 112.5,
    y: 213.5,
    width: 158,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 112.5,
    y: 260.5,
    width: 158,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M267.5,172.95v118.55H118.5v-118.55c0-3.84-3.11-6.95-6.95-6.95h-35.59c-3.84,0-6.95,3.11-6.95,6.95v129.09c0,3.84,3.11,6.95,6.95,6.95h233.09c3.84,0,6.95-3.11,6.95-6.95v-129.09c0-3.84-3.11-6.95-6.95-6.95h-34.59c-3.84,0-6.95,3.11-6.95,6.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69,271.95l49.5-52.03v-46.97c0-3.63-2.78-6.61-6.33-6.92l-43.17,43.81v62.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.5,291.49l48.5-49.98v-68.55c0-3.84-3.11-6.95-6.95-6.95h-.1l-41.45,47.05v78.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.72,291.5h-38.22v-30.62l-49.33,42.67c.69,3.12,3.46,5.45,6.79,5.45h66.48l14.29-17.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.49 291.5 198.4 291.5 182.99 309 250.51 309 267.49 291.5"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 95.5,
    cy: 192.5,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 96,
    cy: 283,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 293.5,
    cy: 192.5,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 294,
    cy: 283,
    r: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 158.5,
    y: 166,
    width: 68,
    height: 82,
    rx: 7.53,
    ry: 7.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.87,211.18c5.67-2.46,9.63-8.1,9.63-14.68,0-8.84-7.16-16-16-16s-16,7.16-16,16c0,6.83,4.29,12.65,10.32,14.94l-7.1,10.56c-1.93,2.88.13,6.75,3.59,6.75h18.38c3.36,0,5.44-3.65,3.72-6.54l-6.55-11.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 16.04,
    y: 49.91,
    width: 12.91,
    height: 12.91,
    rx: 3.93,
    ry: 3.93,
    transform: "translate(46.45 .6) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 30,
    y: 13,
    width: 23,
    height: 23,
    rx: 3.93,
    ry: 3.93,
    transform: "translate(29.48 -22.17) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 336.92,
    y: 121.79,
    width: 17.16,
    height: 17.16,
    rx: 3.93,
    ry: 3.93,
    transform: "translate(193.38 -206.12) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondsChest);
export default __webpack_public_path__ + "static/media/diamonds_chest.dff8bc98b7a921a53e3b8a114588a1ea.svg";
export { ForwardRef as ReactComponent };